import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { UserGroup, UserGroupIcons } from "../../../app/app.interfaces";
import { UserGroupService } from "../../../services/user-group.service";

@Component({
	selector: 'admin-user-group-create',
	templateUrl: 'admin-user-group-create.html'
})


export class AdminUserGroupCreate implements OnInit {

	form: FormGroup;
	edit: boolean = false;
	userGroupIcons: string[] = UserGroupIcons;
	@Output() groupCreated: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder){
	}


	ngOnInit(): void {

		this.buildForm();

	}

	buildForm(): void{

		this.form = this.formBuilder.group({
			name: ['', Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
			abbreviation: ['', Validators.compose([Validators.minLength(2), Validators.maxLength(100)])],
			description: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(400)])],
			icon: ['', Validators.compose([Validators.required])]
		});

	}
	
	toggleEdit(show){
		if(show===undefined) this.edit = !this.edit;
		else this.edit = show;
	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if(this.form.valid){

			let newUserGroup = FormHelper.createObjectFromFormValues(this.form);

			this.apiService.createResource('user_groups', newUserGroup).then((userGroup) => {

				this.form.reset();
				this.ionic.toggleLoader(false);
				// this.togglePopup(false);
				this.ionic.toast('ADMIN.GROUPS.CREATED_TOAST');
				this.edit = false;
				
				this.groupCreated.emit(userGroup);


			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.GROUPS.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ADMIN.GROUPS.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-user-group-create/admin-user-group-create.ts